import { isTauri } from '@/tauri/utils';

import { AuthProvider } from './persistedAuthProvider';

/**
 * Whether the active auth provider is Kinde.
 *
 * Web sets `authProvider = KINDE` explicitly (via the `<Auth>` wrapper in
 * `components/utils/auth.tsx`). The desktop tree (`TauriWrapper`) has no such
 * setter — a Kinde desktop user's `authProvider` stays `undefined`, and the
 * app's established convention (see `isAuth0Desktop` in `tauriAuth.tsx`) treats
 * an unset provider as Kinde. So a strict `authProvider === KINDE` check is a
 * web-only invariant that silently fails on desktop.
 *
 * Resolves "is Kinde" for both platforms: explicit `KINDE` (web), or desktop
 * with an unset provider. The desktop branch is gated on `isTauri()` so the
 * "unset = Kinde" convention never leaks to web — on web an unset provider
 * means logged-out / not-yet-resolved, not Kinde.
 */
export function isKindeProvider(authProvider: AuthProvider | undefined | null): boolean {
  if (authProvider === AuthProvider.KINDE) return true;
  return isTauri() && !authProvider;
}
